module.exports = __webpack_public_path__ + "img/circle.0fef12a3.svg";